const Previous = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_233_21346)">
        <path
          d="M7.42743 7.42676L4 10.8576L7.42857 14.2862"
          stroke="white"
          strokeWidth="1.14286"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M9.71429 17.7148H15.4286C17.7143 17.7148 18.8571 16.572 18.8571 14.2862C18.8571 12.0005 17.7143 10.8577 15.4286 10.8577H4"
          stroke="white"
          strokeWidth="1.14286"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_233_21346">
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default Previous;
